export const capitalizeString = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const formatStringToRemoveDashAndCapitalizeCharacter = (
  word: string,
): string => {
  word = word.replace(/-/g, '')

  const words = word.split('_').map((word) => {
    return word
  })

  return words.join(' ')
}

export const secondsToDHMS = (seconds: number) => {
  seconds = Number(seconds)
  const d = Math.floor(seconds / (3600 * 24))
  const h = Math.floor((seconds % (3600 * 24)) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)
  // console.log(d, h, m, s)
  return {
    days: d,
    hours: h,
    minutes: m,
    seconds: s,
  }
}

export const cleanUrlAndReturnDomainOnly = (inputUrl: string) => {
  // Remove "http://" or "https://"
  let cleanedUrl = inputUrl?.replace(/^https?:\/\//, '')

  // Remove trailing "/"
  cleanedUrl = cleanedUrl?.replace(/\/$/, '')

  return cleanedUrl
}
